import {
  Timestamp,
  type DocumentData,
  type DocumentSnapshot,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { PdSymptom } from '@domain/models/pd-hacks'

function toOptionalDate(value: unknown): Date | undefined {
  if (value instanceof Timestamp) {
    return value.toDate()
  }
  if (value instanceof Date) {
    return value
  }
  return undefined
}

function toOptionalNumber(value: unknown): number | undefined {
  if (typeof value === 'number') {
    return value
  }
  return undefined
}

function stripNullish(
  payload: Record<string, unknown>,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null),
  )
}

export function fromFirestorePdSymptom(
  docSnap: DocumentSnapshot<DocumentData> | QueryDocumentSnapshot<DocumentData>,
): PdSymptom {
  const data = (docSnap.data() ?? {}) as Record<string, unknown>

  return {
    uid: docSnap.id,
    name: typeof data['name'] === 'string' ? data['name'] : undefined,
    createdTime: toOptionalDate(data['created_time']),
    image: typeof data['image'] === 'string' ? data['image'] : undefined,
    solutionCount: toOptionalNumber(data['solution_count']),
    michelsPdHacksVideoUrl:
      typeof data['michels_pd_hacks_video_url'] === 'string'
        ? data['michels_pd_hacks_video_url']
        : undefined,
    pdHacksCategoryId:
      typeof data['pd_hacks_category_id'] === 'string'
        ? data['pd_hacks_category_id']
        : typeof data['pdHacksCategoryId'] === 'string'
          ? data['pdHacksCategoryId']
          : undefined,
  }
}

export function toFirestorePdSymptomPatch(
  input: Partial<PdSymptom>,
): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    name: input.name?.trim(),
    created_time: input.createdTime ? Timestamp.fromDate(input.createdTime) : undefined,
    image: input.image?.trim(),
    solution_count: input.solutionCount,
    michels_pd_hacks_video_url: input.michelsPdHacksVideoUrl?.trim(),
    pd_hacks_category_id: input.pdHacksCategoryId?.trim(),
  }

  return stripNullish(payload)
}
